import { lazy, Suspense, useState } from 'react';
import { Button } from 'antd';
import { useAppDispatch } from 'app/hooks';
import Spin from 'components/Spin';
import Alert from 'components/Alert';
import LazySvg from 'components/LazySvg';
import If from 'components/If';
import { setDataCollectionBannerClosed } from 'services/misc/miscSlice';
import { QaDashboardPage } from 'testdata/constants';
import styles from './index.module.scss';

const DataCollectionModal = lazy(() => import('pages/DataCollectionModal'));

function DataCollectionBanner() {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleBannerClose = () => {
    dispatch(setDataCollectionBannerClosed(true));
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Alert
        className={styles.dataCollectionBanner}
        data-qa-selector={QaDashboardPage.bannerPiiRequired}
        message={
          <>
            <span data-qa-selector={QaDashboardPage.textBannerPiiRequired}>
              We need additional information about you to activate some
              features.
            </span>{' '}
            <Button
              type='link'
              className='alertLinkText'
              onClick={handleModalOpen}
              data-qa-selector={QaDashboardPage.buttonBannerPiiActivateNow}
            >
              Activate now.
            </Button>
          </>
        }
        type='error'
        icon={<LazySvg name='toast-error' className={styles.icon} />}
        showIcon
        closable={{
          'aria-label': 'close',
          closeIcon: (
            <LazySvg
              name='close'
              className={`${styles.icon} ${styles.closeIcon}`}
            />
          ),
        }}
        onClose={handleBannerClose}
      />
      <If condition={isModalOpen}>
        <Suspense fallback={<Spin fullscreen />}>
          <DataCollectionModal
            isModalOpen
            handleClose={handleModalClose}
            skipIntro
          />
        </Suspense>
      </If>
    </>
  );
}

export default DataCollectionBanner;
